import { useMutation, useQuery } from "@tanstack/react-query";
import axios from "axios";
import { IQueryParams } from "queries";
import helpers from "helpers/index";
import queryClient from 'queries';


export interface TypedVehicle {
    id?: string;
    name?: string;
    note?: string;
    license_plate?: string;
    vehicle_status?: number; // 1 là đang hoạt động, 0 là không hoạt động

    sum_of_income?: number; // tổng thu nhập
    sum_of_trip?: number; // tổng chi phí
    sum_of_distance?: number; // tổng KM


    createdAt?: string;
    endedAt?: string;

    sum?: {
        sum_of_log: number, // số chuyến
        sum_of_distance: number, // số chuyến
        sum_of_time: number, // số ngày tham gia
        sum_of_income: number,
    }
}


export enum ENUM_VEHICLE_STATUS {
    ACTIVE = 1,
    INACTIVE = 0,
}


type IQuery = TypedVehicle & IQueryParams;


export interface vehicleStat { vehicle_id: any; sum_of_income: number; sum_of_trip: number; sum_of_distance: number; }

/*
* List of all app
*/
export function useGetVehicles(object: IQuery) {
    const EndURL = helpers.buildEndUrl(object);
    return useQuery({
        queryKey: ["vehicle/fetch_entity_list", object],
        queryFn: () => axios.get<TypedVehicle[]>(`/vehicle${EndURL}`).then(response => {
            let { data, headers } = response;
            return {
                body: data,
                totalItems: Number(headers['x-total-count'] || 0)
            }
        }),
        retry: 1,
        enabled: true,
    });
}

/** stats */
export function useGetVehicleStats(dateRange: string) {
    const EndURL = helpers.buildEndUrl(dateRange ? { createdAt: (dateRange).toString() } : '');

    return useQuery({
        queryKey: ["vehicle/fetch_stat_list", dateRange],
        queryFn: () => axios.get<vehicleStat[]>(`/vehicle/stats/${EndURL}`).then(response => response.data),
        retry: 1,
        enabled: !!dateRange,
    });
}



export function useGetVehicle(vehicle_id: string) {
    return useQuery({
        queryKey: ['vehicle/fetch_entity'],
        queryFn: () => axios.get<TypedVehicle>(`/vehicle/${vehicle_id}`).then((response) => response.data),
        retry: 1,
        // enabled: false,
    });
}


export function useMutateGetVehicles() {
    return useMutation({
        mutationKey: ['vehicle/fetch_entity_list'],
        mutationFn: (object: IQuery) => axios.get<TypedVehicle>(`/vehicle/${helpers.buildEndUrl(object)}`).then((response) => response.data),
    });
}

export function useMutateGetVehicle() {
    return useMutation({
        mutationKey: ['vehicle/fetch_entity'],
        mutationFn: (vehicle_id: any) => axios.get<TypedVehicle>(`/vehicle/${vehicle_id}`).then((response) => response.data),
    });
}


export function useUpdateVehicle() {
    return useMutation({
        mutationKey: ['vehicle/update_entity'],
        mutationFn: ({ id, ...rest }: TypedVehicle) => axios.patch<TypedVehicle>(`/vehicle/${id}`, helpers.cleanEntity(rest)).then((response) => response.data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['vehicle/fetch_entity_list'] });
            queryClient.invalidateQueries({ queryKey: ['vehicle/fetch_entity'] });
        }
    });
}


export function useMutateCreateVehicle() {
    return useMutation({
        mutationKey: ['vehicle/create_entity'],
        mutationFn: (entity: TypedVehicle) => axios.post<TypedVehicle>(`/vehicle`, helpers.cleanEntity(entity)).then(response => response.data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['vehicle/fetch_entity_list'] });
        }
    });
}

export function useMutateDeleteVehicle() {
    return useMutation({
        mutationKey: ['vehicle/delete_entity'],
        mutationFn: (id: any) => axios.delete<TypedVehicle>(`/vehicle/${id}`).then(response => response.data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['vehicle/fetch_entity_list'] });
        }
    });
}

/** Tính toán lại dữ liệu cho toàn bộ xe, cái này ít dùng nhưng phải dùng để đồng bộ lần đầu ... */
export function useMutateReloadVehicleData() {
    return useMutation({
        mutationKey: ['vehicle/reload_entity'],
        mutationFn: () => axios.get<any>(`/vehicle/reload/`).then(response => response.data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['vehicle/fetch_entity_list'] });
        }
    });
}